import { render, staticRenderFns } from "./analogsRender.vue?vue&type=template&id=023c5c7a&scoped=true"
import script from "./analogsRender.vue?vue&type=script&lang=js"
export * from "./analogsRender.vue?vue&type=script&lang=js"
import style0 from "./analogsRender.vue?vue&type=style&index=0&id=023c5c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c5c7a",
  null
  
)

export default component.exports